import LegalPage from "@/pages/LegalPage";

export default function ShippingPolicy() {
  return (
    <LegalPage title="Shipping Policy" subtitle="Delivery" testId="shipping-page">
      <p>We ship across India from our studio in Dharuhera, Haryana. Every order is packed with care and dispatched through trusted courier partners.</p>

      <h2>Processing Time</h2>
      <ul>
        <li>Orders are processed within 1–2 business days after payment confirmation.</li>
        <li>Orders placed on weekends or public holidays are processed on the next business day.</li>
      </ul>

      <h2>Delivery Time</h2>
      <ul>
        <li>Metros: 3–5 business days.</li>
        <li>Non-metros: 5–8 business days.</li>
        <li>Remote areas: 7–10 business days.</li>
      </ul>

      <h2>Shipping Charges</h2>
      <ul>
        <li>FREE shipping across India on all prepaid orders above ₹999.</li>
        <li>A flat shipping fee of ₹49 applies to orders below ₹999.</li>
        <li>Cash on Delivery (COD) is available across India.</li>
      </ul>

      <h2>Order Tracking</h2>
      <p>Once shipped, you'll receive a tracking number via email/WhatsApp. You can also track your order any time from the <a href="/track">Track Order</a> page using your order ID.</p>

      <h2>Undelivered / Returned Packages</h2>
      <p>If a package is returned to us due to an incorrect address or unavailable recipient, we'll contact you to arrange re-shipment. Additional shipping charges may apply.</p>

      <h2>Need Help?</h2>
      <p>Reach us on WhatsApp at +91 97299 27206 or email <a href="mailto:thefabrics37@gmail.com">thefabrics37@gmail.com</a>.</p>
    </LegalPage>
  );
}
